<template>

  <div class="list-bed"
       v-if="listAdd.length>0">
    <div class="list-li"
         v-for="(item, index) in listAdd"
         :key="index">
      <div class="li-title"><span>{{item.cardName}}充值</span><span style="color:#2489FF">{{item.orderAmt/100}}元</span></div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">充值时间</div>
          <div class="li-val">{{item.orderGenerateTime}}</div>
        </div>
        <div class="li-box">
          <div class="li-key">充值卡号</div>
          <div class="li-val">{{item.cardNo}}</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付方式</div>
          <div class="li-val"
               v-if="item.payWay=='80'">建行支付</div>
          <div class="li-val"
               v-if="item.payWay=='20'">微信支付</div>
          <div class="li-val"
               v-if="item.payWay=='22'">支付宝支付</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付状态</div>
          <div class="li-val"
               v-if="item.orderStatus=='success'">成功</div>
          <div class="li-val"
               v-if="item.orderStatus=='failed'">失败</div>
          <div class="li-val"
               v-if="item.orderStatus=='unknown'">下单</div>
        </div>
      </div>
    </div>
    <!-- <div class="list-li">
      <div class="li-title"><span>学生卡充值</span><span style="color:#2489FF">50元</span></div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">充值时间</div>
          <div class="li-val">2022-02-02 09:54</div>
        </div>
        <div class="li-box">
          <div class="li-key">充值卡号</div>
          <div class="li-val">4111022550041458</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付方式</div>
          <div class="li-val">微信支付</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付状态</div>
          <div class="li-val">成功</div>
        </div>
      </div>
    </div>
    <div class="list-li">
      <div class="li-title"><span>普通卡充值</span><span style="color:#2489FF">50元</span></div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">充值时间</div>
          <div class="li-val">2022-02-02 09:54</div>
        </div>
        <div class="li-box">
          <div class="li-key">充值卡号</div>
          <div class="li-val">4111022550041458</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付方式</div>
          <div class="li-val">微信支付</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付状态</div>
          <div class="li-val">成功</div>
        </div>
      </div>
    </div>
    <div class="list-li">
      <div class="li-title"><span>普通卡充值</span><span style="color:#2489FF">50元</span></div>
      <div class="li-con">
        <div class="li-box">
          <div class="li-key">充值时间</div>
          <div class="li-val">2022-02-02 09:54</div>
        </div>
        <div class="li-box">
          <div class="li-key">充值卡号</div>
          <div class="li-val">4111022550041458</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付方式</div>
          <div class="li-val">微信支付</div>
        </div>
        <div class="li-box">
          <div class="li-key">支付状态</div>
          <div class="li-val">成功</div>
        </div>
      </div>
    </div> -->
  </div>
  <div v-else>
    <img src="../assets/img/no_list.png"
         style="width:320px;height:302px" />
  </div>

</template>

<script>
import { queryOrder } from '@/api/list'

export default {
  name: 'listAdd',
  data () {
    return {
      loading: true,
      listAdd: []
    }
  },

  components: {

  },
  mounted () {
    const params = {
      selectType: "gateway",
      selectPramType: "uid",
      selectPram: JSON.parse(window.sessionStorage.getItem('userInfo')).uid,
      payPurpose: '02'
    }
    queryOrder(params).then(data => {
      if (data.respCode === '01') {
        this.listAdd = data.data.orderList
        // this.isShow_sure = true

      } else {
        // this.msg = data.respMsg;
        // this.isShow_fail = true
      }
    }).catch(err => {
      this.$eventBus.$emit('getTipsInfo', {
        msg: err
      })
    })

  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-bed {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  // flex-wrap: wrap;
  width: 100%;

  > .list-li {
    // border-bottom: 3px solid #eee;
    width: calc(100% - 64px);
    // height: 330px;
    margin-bottom: 16px;
    padding-bottom: 4px;
    // box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .li-title {
      width: calc(100% - 48px);
      height: 82px;
      border-bottom: 1px solid #e8ebf0;
      font-size: 30px;
      font-family: 宋体;
      font-weight: 500;
      color: #333333;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .li-con {
      width: calc(100% - 48px);
      padding-top: 16px;

      .li-box {
        height: 37px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        margin-bottom: 20px;
        .li-key {
          width: 30%;
          height: 100%;
          font-size: 26px;
          font-family: 宋体;
          font-weight: 400;
          color: #8f98a8;
        }
        .li-val {
          width: 70%;
          height: 100%;
          font-size: 26px;
          font-family: 宋体;
          font-weight: 400;
          color: #333333;
          text-align: right;
        }
      }
    }
  }
}
</style>
